// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UsuM","badges":"styles_badges__3WLzl"};